module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.ea28cc32.jpg";